// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KQ_U","title":"Info_title__ncAnw","links":"Info_links__1EK_A","link":"Info_link__zn9u-","logo":"Info_logo__3iQ7z"};